export var PersonalizedViewState;
(function (PersonalizedViewState) {
    PersonalizedViewState[PersonalizedViewState["Empty"] = 0] = "Empty";
    PersonalizedViewState[PersonalizedViewState["Loader"] = 1] = "Loader";
    PersonalizedViewState[PersonalizedViewState["Events"] = 2] = "Events";
})(PersonalizedViewState || (PersonalizedViewState = {}));
//# sourceMappingURL=PersonalizedViewState.js.map